<template>
  <v-text-field @input="handleInput" :height="height" :label="label" :value="numberValue" :rules="rules" :disabled="disabled"></v-text-field>
</template>

<script>
export default {
  name: 'number-field',

  props: ['value', 'label', 'rules', 'height', 'disabled'],

  data: function () {
    return {
      numberValue: this.value != null ? this.value.toString() : null
    }
  },

  methods: {

    handleInput (ev) {
      if (ev != null && ev != '') {
        let v = parseFloat(ev.replace(',', '.'))
        if (!isNaN(v)) {
          this.numberValue = ev
          this.$emit('input', v)
        }
      } else {
        this.$emit('input', null)
      }
    }

  }

}
</script>
